import React, {useState} from "react"
import { Div, Tag, Anchor, Icon } from "atomize";
import useCollapse from 'react-collapsed';
import styled from "styled-components";
import theme from "../../../Theme/Theme";

const Wrapper = styled.div`
  // margin-left: 4rem;
  margin-bottom: 1.5rem;
`;
const Question = styled.a`
    color: ${theme.colors.dark};
    font-size: 16px;	
    font-weight: bold;	
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const Answer = styled(Div)`
  margin: .5rem 0;
`;

const Icons = styled(Icon)`
`;

function Faq(props) {
  const {getCollapseProps, getToggleProps, isOpen} = useCollapse({
    expandStyles: {
      transitionDuration: '250ms',
      transitionTimingFunction: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)'
    },
    collapseStyles: {
      transitionDuration: '250ms',
      transitionTimingFunction: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)'
    }
  });
  return (
    <Wrapper>
      <Question
        {...getToggleProps()}
        aria-expanded={ isOpen }
      >
        {props.question}

        <Icons
          name={ !isOpen ? "DownArrow" : "UpArrow" }
          size="20px"
          color={theme.colors.primary}
        />

      </Question>
      <Answer
        {...getCollapseProps()}
      >
        <Div dangerouslySetInnerHTML={{ __html: props.answer }} />
      </Answer>

    </Wrapper>
  )
}



export default Faq
